import { useEffect, useRef } from "react";

export default function Booking({ t }) {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!document.getElementById('hubspot-meetings-script')) {
      const script = document.createElement('script');
      script.id = 'hubspot-meetings-script';
      script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      script.async = true;
      document.body.appendChild(script);
    }

    if (widgetRef.current) {
      const observer = new MutationObserver(() => {
        const iframe = widgetRef.current?.querySelector('iframe');
        if (iframe && !iframe.title) {
          iframe.title = t.bookingTitle;
        }
      });
      observer.observe(widgetRef.current, { childList: true, subtree: true });
      return () => observer.disconnect();
    }
  }, [t.bookingTitle]);

  return (
    <section id="termin" className="booking-section" data-testid="booking-section">
      <div className="section-inner">
        <div className="section-label fade-in">{t.bookingLabel}</div>
        <h2 className="section-title fade-in">{t.bookingTitle}</h2>
        <p className="booking-desc fade-in">{t.bookingDesc}</p>
        <div className="booking-widget fade-in-scale" data-testid="hubspot-booking" ref={widgetRef} style={{ transitionDelay: "0.15s" }}>
          <div className="meetings-iframe-container" data-src="https://meetings-eu1.hubspot.com/dominik-mietke?embed=true"></div>
        </div>
      </div>
    </section>
  );
}
